import { createConsumer }                 from "@rails/actioncable"

export const cableSubscription = (identifier, hanlders) => {
  return createConsumer().subscriptions.create(identifier, hanlders)
}
